<template>
	<ContainerCenter>
		<v-card>
			<v-toolbar
				color="primary"
				dark
				flat
			>
				<v-toolbar-title>Olá, {{ usuario.nomeCompleto }} </v-toolbar-title>
			</v-toolbar>
			<v-card-text>
				<v-form
					ref="form"
					@submit.prevent="revalidarPalavraSemestral"
					id="form-registro"
				>
					<v-text-field
						name="cim"
						label="CIM"
						:value="usuario.cim"
						required
						disabled
					/>
					<div class="body-1 text-center">
						Confirme a palavra semestral para continuar
					</div>
					<v-text-field
						name="palavra"
						label="Palavra"
						v-model="palavra"
						:class="{ 'dot-field': !verPalavra }"
						:append-icon="verPalavra ? 'mdi-eye-off' : 'mdi-eye'"
						@click:append="() => verPalavra = !verPalavra"
						:rules="[ obrigatorio ]"
						autocomplete="do-not-autofill"
					/>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-btn
					block
					color="primary"
					type="submit"
					form="form-registro"
					:disabled="carregando"
					:loading="carregando"
				> Confirmar Palavra </v-btn>
			</v-card-actions>
		</v-card>
	</ContainerCenter>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue'
import ContainerCenter from '@/components/ui/ContainerCenter.vue'
import { InputIrmao } from '../../common/types/Irmao'
import { obrigatorio } from '../shareds/regras'
import { revalidarPalavra } from '@/services/AuthService'
import { alert, authModule } from '@/store'
import { useRouter } from '@/composables/router'

defineProps({
	usuario: { type: Object as PropType<Pick<InputIrmao, 'nomeCompleto' | 'cim'>> },
})

const router = useRouter()

const form = ref<HTMLFormElement & {
	validate: () => boolean,
}>()

const carregando = ref(false)
const verPalavra = ref(false)
const palavra = ref('')

async function revalidarPalavraSemestral() {
	if (!form.value!.validate()) return
	try {
		carregando.value = true
		const { data } = await revalidarPalavra({
			palavra: palavra.value,
		})
		await authModule.logarToken(data)
		router.push({ name: 'home' })

	} catch (error) {
		alert.setError(error)
	} finally {
		carregando.value = false
	}
}
</script>

<style scoped>
.dot-field >>> input {
    -webkit-text-security: disc;
}
</style>
